<template>
  <div>
    <WizardStep :hideFooter="true">
      <template v-slot:content>
        <div class="col">
          <div class="col-xl-12">
            <div class="card">
              <div class="card-header">
                <h5 class="mb-0">MFA Device</h5>
              </div>
              <div class="card-body">
                <div v-if="device" class="device-card">
                  <div class="device-card__icon">
                    <i class="flaticon2-lock"></i>
                  </div>
                  <div class="device-card__info">
                    <h6 class="mb-1">{{ device.name }}</h6>
                    <small class="text-muted">{{ device.type }}</small>
                  </div>
                  <div class="device-card__action">
                    <b-button
                      size="sm"
                      variant="warning"
                      @click="changeDevice(device.deviceKey)"
                    >
                      Change
                    </b-button>
                  </div>
                </div>
                <div v-else class="text-center">
                  <p class="text-muted mb-3">No MFA device configured</p>
                  <b-button
                    variant="primary"
                    @click="$router.push({ name: 'setup-mfa' })"
                  >
                    Add MFA Device
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </WizardStep>

    <LoadingModal v-bind="loadingModal" />
    <AlertModal
      v-bind="alertModal"
      v-model="alertModal.show"
      @dismiss="resetAlert"
    />
    <ConfirmationModal
      v-bind="confirmationModal"
      v-model="confirmationModal.show"
      @dismiss="resetConfirmation"
    />
  </div>
</template>

<script>
import WizardStep from "@/components/wizard/WizardStep";
import AlertModalMixin from "@/components/widgets/AlertModalMixin.js";
import { GET_MFA_DEVICES } from "@/store/auth.module";

const AlertModal = AlertModalMixin.AlertModal;
const ConfirmationModal = AlertModalMixin.ConfirmationModal;

export default {
  name: "mfa-devices",
  mixins: [AlertModalMixin],
  components: { WizardStep },
  data() {
    return {
      device: null
    };
  },
  async mounted() {
    await this.loadDevices();
  },
  methods: {
    async loadDevices() {
      this.startLoadingDialog("Loading MFA device");
      try {
        const devices = await this.$store.dispatch(GET_MFA_DEVICES);
        this.device = devices.length ? devices[0] : null;
        this.stopLoadingDialog();
      } catch (e) {
        this.$logger.error(e);
        this.stopLoadingDialog("Error loading MFA device", AlertModal.ERROR);
      }
    },
    async changeDevice(deviceKey) {
      const confirmed = await this.confirm(
        "Change MFA Device",
        "You will be taken through the setup process to register a new device. Your old device will be replaced.",
        ConfirmationModal.WARNING
      );
      if (!confirmed) return;
      this.$router.push({ name: "setup-mfa", query: { change: true } });
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  border: 1px solid #e3e6f0;
  border-radius: 0.35rem;
}
.card-header {
  background-color: #f8f9fc;
  border-bottom: 1px solid #e3e6f0;
  padding: 0.75rem 1.25rem;
}
.card-body {
  padding: 1.25rem;
}
.device-card {
  display: flex;
  align-items: center;
  padding: 1rem;
  border: 1px solid #e3e6f0;
  border-radius: 0.35rem;
  background-color: #f8f9fc;

  &__icon {
    font-size: 2rem;
    color: #5867dd;
    margin-right: 1rem;
  }

  &__info {
    flex: 1;
  }

  &__action {
    margin-left: 1rem;
  }
}
</style>
